<template>
    <div>
        <header3 :title="title" />
        <div class = "content_viptop" v-if="!loading">
            <div>
                <div class="div_imgviptop">
                    <img class = "imgviptop" :src="img"/>
                    <div class="iconvip" >
                     <span>VIP</span>
                </div>
                </div>
                <div class="titleviptop"><span >VIP объявление</span></div>
                <div class="senaviptop"><span >{{ textsenavip }}</span></div>
                <div class="textinfoviptop"><span >Показывается выше TOP</span></div>
                <div class="textinfoviptop"><span >Больше просмотров и звоноков</span></div>
                <div><button class = "buttonviptop" @click="vip()">{{ textbuttonvip }}</button></div>
            </div>
            <div class="margin_bottom_kart"></div>
            <div>
                <div class="div_imgviptop">
                    <img class = "imgviptop" :src="img"/>
                    <div class="icontop" >
                     <span>TOP</span>
                </div>
                </div>
                <div class="titleviptop"><span >TOP объявление</span></div>
                <div class="senaviptop"><span >{{ textsenatop }}</span></div>
                <div class="textinfoviptop"><span >Показывается выше обычных объявлений</span></div>
                <div class="textinfoviptop"><span >Больше просмотров и звоноков</span></div>
                <div><button class = "buttonviptop" @click="top()">{{ textbuttontop }}</button></div>
            </div>

        </div>
        <br/><br/><br/><br/>
        <div v-if="loading" align="center"><Spinner /></div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import header3 from "../blocks/header3";
  import Spinner from "../blocks/spinner";
  export default {
     components:{
        header3, Spinner,
     },
    data() {
      return {
        id:0,
        title:"Условия публикации",
        img:"",
        senavip:0,
        senatop:0,
        textsenavip:"5 дней за 56 с.",
        textsenatop:"5 дней за 25 с.",
        textbuttonvip:"Опубликовать VIP за 56 с.",
        textbuttontop:"Опубликовать TOP за 25 с.",
        balans:0,
        loading:false,

      
      };
    },
    methods: {
       getinfoviptop(){
        this.loading = true;
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/getInfoVipTopObv",
          data: {
            token: localStorage.getItem("token"),
            id: this.id,
          },
        })
          .then((res) => {
            if (res.data.status) {
               this.loading=false;
               this.img = res.data.image;
               this.senavip = res.data.senavip;
               this.senatop = res.data.senatop;
               this.balans=res.data.balans;
               this.textbuttonvip = "Опубликовать VIP за " + this.senavip + " c.";
               this.textbuttontop = "Опубликовать TOP за " + this.senatop + " c.";
               this.textsenavip = res.data.srok + " дней за " + this.senavip + " c.";
               this.textsenatop = res.data.srok + " дней за " + this.senatop + " c.";
            }else alert("Error") 
          })
          .catch((error) => {
            if (!error.response) {
              alert("Error")
            }
          });
       },
       vip(){
           if(this.senavip > this.balans){
             this.$router.push({ name: "fillupbalans" });
           }else this.addviptop(2)
       },
       top(){
           if(this.senatop > this.balans){
             this.$router.push({ name: "fillupbalans" });
           }else this.addviptop(1)
       },
       addviptop(tip){
        this.loading = true;
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/addVipTopObv",
          data: {
            statusviptop:tip,
            id: this.id,
            token: localStorage.getItem("token"),

          },
        })
          .then((res) => {
            if (res.data.status) {
               this.loading=false;
               localStorage.removeItem("idviptop");
               localStorage.setItem ("restart",true);
               this.$router.go(-1);
            }else alert("Error") 
          })
          .catch((error) => {
            if (!error.response) {
              alert("Error")
            }
          });
       }

    },
    created() {
      if (!localStorage.getItem("token")) {
         this.$router.go(-1); 
        }else{
            if(localStorage.getItem("idviptop")){
              this.id=localStorage.getItem("idviptop");
              this.getinfoviptop();
            }else this.$router.go(-1); 
        } 
    },
    mounted (){
     
    }
  };
  </script>
  <style scoped>
  .content_viptop{
    width: 100%;
    max-width: 400px;
    margin-top: 60px;
    margin-bottom: 20px;
    
  }
  .div_imgviptop{
    position: relative;
    display: inline-block;
    width: 100%;
    margin-top: 10px;
    z-index: 30;
  }
  .imgviptop{
    width: 100%;
    border-radius: 8px;
    background-color: #f5f5f5;
  }
  .titleviptop{
    margin-top: 5px;
    color: #000;
    font-size: 20px;
  }
  .senaviptop{
    margin-top: 5px;
    color: #000;
    font-size: 20px;
    font-weight: bold;
  }
  .textinfoviptop{
    margin-top: 5px;
    color: #666;
    font-size: 18px;
  }
  .buttonviptop{
    background: none;
    background-color: #0b76ef;
    padding: 14px 12px;
    border: none;
    border-radius: 5px;
    margin-top: 5px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    width: 100%;
  }
  .buttonviptop:hover{
    background-color: #1381fd;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0);
    cursor: pointer;
  }
  </style>